import TemplateView from "../../TemplateView"

export default class ModalAlertLine extends TemplateView {
    constructor({
        lineText = '',
    }) {
        super()
        this.lineText = lineText
    }

    templateHtml() {
        return "<div class='modalAlertLine'><%-lineText%></div>"
    }
}



// WEBPACK FOOTER //
// ./web/js/components/modalAlert/ModalAlertLine.js